<template>
	<div class="information">
		<div class="information-hr"></div><div class="information-hr2"></div>
		<p style="color: black;">您可以随时修改编辑您的个人资料，带*号的为必填项目，需全部填写才能保证修改</p>
        <div class="">
        	<span class="changeMsg">当前头像</span>
		    <img :src="imgDataUrl" alt="" class="personChange"/>
        	<el-button type="primary" @click="toggleShow" round>上传头像</el-button>
		    <my-upload field="img"
		        @crop-success="cropSuccess"
		        @crop-upload-success="cropUploadSuccess"
		        @crop-upload-fail="cropUploadFail"
		        v-model="show"
		        :width="100"
		        :height="100"
		        :url="urls"
		        :params="params"
		        :headers="headers"
		        :noCircle="true"
		        :withCredentials="true"
		        img-format="jpg"></my-upload>
        </div>
		<!-- <img :src="photoURL" alt="" class="personChange" />
		<el-upload class="upload" :action="uploadHost" :show-file-list="false" :on-success="handleSuccess" :data="ossParams" :on-change="handleChange">
			<el-button type="primary" round>更换头像</el-button>
		</el-upload> -->
	    <el-form :model="form" label-width="80px">
		  <el-form-item label="昵称/笔名">
		    <el-input v-model="form.nick" class="inputName"></el-input>
		  </el-form-item>
		  <el-form-item label="真实姓名">
		    <el-input v-model="form.real_name" class="inputName"></el-input>
		    <img src="../assets/img/xing.png"/><span v-show="Isrealname">不能为空</span>
		  </el-form-item>
		  <el-form-item label="生日">
		    <el-date-picker type="date" placeholder="选择日期" v-model="form.birthday" value-format="yyyy-MM-dd" class="inputName left" :picker-options="options"></el-date-picker>
		  </el-form-item>
		  <el-form-item label="">
		    <el-checkbox-group v-model="form.use_nick">
		      <el-checkbox label="" name="type" >勾选保存按钮之后，我们会对外宣传或者公布信息时候，使用昵称/笔名而非您的真实姓名</el-checkbox>
		    </el-checkbox-group>
		  </el-form-item>
		  <el-form-item label="性别">
		    <el-radio-group v-model="form.sex">
		      <el-radio label="男" value='1'></el-radio>
		      <el-radio label="女" value='2'></el-radio>
		    </el-radio-group>
		    <img src="../assets/img/xing.png"/><span v-show="Issex">不能为空</span>
		  </el-form-item>
		  <el-form-item label="国家/地区">
		    <el-input v-model="form.country" class="inputName"></el-input>
		    <img src="../assets/img/xing.png"/><span v-show="Iscountry">不能为空</span>
		  </el-form-item>
		  <el-form-item label="通讯地址">
		    <el-input v-model="form.address" class="inputName"></el-input>
		    <img src="../assets/img/xing.png"/><span v-show="Isaddress">不能为空</span>
		  </el-form-item>
		  <el-form-item label="E-mail">
		    <el-input v-model="form.email" class="inputName"></el-input>
		    <img src="../assets/img/xing.png"/><span v-show="Isemail">请重新填写E-mail</span>
		  </el-form-item>
		  <el-form-item label="联系电话">
		    <el-input v-model="form.phone" class="inputName"></el-input>
		    <img src="../assets/img/xing.png"/><span v-show="Isphone">请重新填写电话</span>
		  </el-form-item>
		  <el-form-item label="QQ">
		    <el-input v-model="form.qq" class="inputName"></el-input>
		    <span v-show="Isqq">请重新填写qq</span>
		  </el-form-item>
		  <el-form-item label="微信">
		    <el-input v-model="form.weixin" class="inputName"></el-input>
		    <span v-show="Isweixin">请重新填写微信</span>
		  </el-form-item>
		</el-form>
	     <el-button type="primary" round class="commitFirst" @click="editPerson">保存修改</el-button>
	     <div class="information-hr-bottom"></div><div class="information-hr2-bottom"></div>
	</div>
</template>

<script>
	import axios from 'axios'
	import { mapGetters } from 'vuex'
	import myUpload from 'vue-image-crop-upload'
	export default {
		data(){
			return{
				fileList1:[],
				form:{
					real_name:'',
					birthday:'',
					sex:'',
					country:'',
					address:'',
					email:'',
					phone:'',
					nick:'',
					use_nick:false,
					qq:'',
					weixin:'',
					avator:'',
				},
				photoURL:'/static/admin.png',
				phoneFile:'',/*
				uploadHost:process.env.BASE_URL+'/oss/get-sign?type=1',
		        ossParams:{
		       	 key: '', // key后面有用，先默认设空字符串
  				 success_action_status: '200', // 默认200
		        },
		        picOSS:false,*/
		        dir:'',
		        imgLink:'',
		        Isrealname:false,
		        Issex:false,
		        Iscountry:false,
		        Isaddress:false,
		        Isemail:false,
		        Isphone:false,
		        Isqq:false,
		        Isweixin:false,
		        options:{
		        	disabledDate(time){
					    return time.getTime() > Date.now();
					},
		        },
		        show: false,
		        params: {},
		        headers: {
		            smail: '*_~'
		        },
		        imgDataUrl: '',
		        urls:process.env.BASE_URL+'/oss/uploadImage'
			}
		},
	    components:{
	      'my-upload': myUpload
	    },
		computed:{
			...mapGetters([
					'imgUrl'
				]),
		},
		methods:{
			toggleShow() {
		        this.show = !this.show;
		    },
		    cropSuccess(imgDataUrl, field){
		        this.imgDataUrl = imgDataUrl
		    },
		    cropUploadSuccess(jsonData, field){
		        this.dir = jsonData.data.absolute_path
		        this.imgLink = jsonData.data.path
		    },
		    cropUploadFail(status, field){
		    },
			handleChange(file,fileList){
				this.photoURL = file.url
				this.phoneFile = file.raw
			},
			editPerson(){
				var sex = 0 
				var edit = true
				if(this.form.real_name.length<1 ){
					this.Isrealname = true;
					edit = false
					window.scrollTo(0,350);
					return;
				} 
				else{
					this.Isrealname = false
				}
				if(this.form.sex.length<1 ){
					this.Issex = true;
					edit = false
					window.scrollTo(0,550);
					return;
				}else{
					this.Issex = false
				}
				if(this.form.country.length<1 ){
					this.Iscountry = true;
					edit = false
					window.scrollTo(0,600);
					return;
				}else{
					this.Iscountry = false
				}
				if(this.form.address.length<1 ){
					this.Isaddress = true;
					edit = false
					window.scrollTo(0,650);
					return;
				}else{
					this.Isaddress = false
				}
				if(this.form.email.length<1 ){
					this.Isemail = true;
					edit = false
					window.scrollTo(0,670);
					return;
				}else{
					this.Isemail = false
				}
				if(this.form.phone.length<1 ){
					this.Isphone = true;
					edit = false
					window.scrollTo(0,690);
					return;
				}else{
					this.Isphone = false
				}
//				if(this.form.qq.length<1 ){this.Isqq = true;edit = false}else{this.Isqq = false}
//				if(this.form.weixin.length<1 ){this.Isweixin = true;edit = false}else{this.Isweixin = false}
				var regBox = {
					regMobile: /^1\d{10}$/, //手机
					regTel: /^1\d{10}$/,
					qq:/^[1-9]*[1-9][0-9]*$/,
					email:/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,4}$/,
					weixin:/^[a-z_\d]+$/
					
				}
				var phone = this.form.phone
				var mflag = regBox.regMobile.test(phone);
				var tflag = regBox.regTel.test(phone);
				var email = regBox.email.test(this.form.email);
				if(!(mflag || tflag)) {this.Isphone = true;edit = false}
				if(!(email)) {this.Isemail = true;edit = false}
				if(edit == true){
					var use_nick=''
					if (this.form.use_nick == false) {
						use_nick = 0
					} else if(this.form.use_nick == true){
						use_nick = 1
					}
					if (this.form.sex == '男') {
						sex = 0
					} else if(this.form.sex == '女'){
						sex = 1
					}
					var form = new FormData
					form.append('real_name',this.form.real_name)
					form.append('sex',sex)
					form.append('country',this.form.country)
					form.append('address',this.form.address)
					form.append('email',this.form.email)
					form.append('phone',this.form.phone)
					form.append('nick',this.form.nick)
					form.append('use_nick',use_nick)
					form.append('birthday',this.form.birthday)
					form.append('qq',this.form.qq)
					form.append('weixin',this.form.weixin)
					form.append('avator',this.imgLink)
					axios({
						method:'post',
						url:process.env.BASE_URL+'/user/edit',
						data:form,
						withCredentials:true
					})
					.then(res=>{
						if (res.data.code == 10000) {
                            this.$confirm('修改成功', '提示', {
					          confirmButtonText: '确定',
					          showCancelButton:false,
					          type: 'success'
					        }).then(() => {
					            this.$store.commit('SET_IMGURL', this.dir)
								this.$store.commit('SET_NAME', this.form.real_name)
								this.photoURL = this.dir
								location.reload()
					        }).catch(() => {     
					        });
						}
						else{
                            this.$confirm(res.data.message, '提示', {
					          confirmButtonText: '确定',
					          showCancelButton:false,
					          type: 'warning'
					        }).then(() => {
					        }).catch(() => {       
					        });

						}
					})
				} else{
//					console.log('头像正在上传到OSS')
				}
			}
			
		},
		created(){
			axios({
		  		method:'post',
		  		url:process.env.BASE_URL+'/user/info',
		  		withCredentials:true
		  	}).then(res =>{
		  		var data = res.data.data

		  		// 对null的字段做处理
		  		for(var kk in data){
		  			if(data[kk] == 'null'){
		  				data[kk] = '';
		  			}
		  		}


		  		this.form = data
		  		if(data.avator == null){
		  			this.imgDataUrl = '/static/admin.png'
		  			this.$store.commit('SET_IMGURL', '/static/admin.png')
		  		} else {
		  			this.imgDataUrl = "http://sgs-dl.oss-cn-shanghai.aliyuncs.com/" + "/" + data.avator
		  			this.$store.commit('SET_IMGURL', this.photoURL)
		  		}
				this.$store.commit('SET_NAME', this.form.real_name)
				this.imgLink = data.avator
				
		  		if (data.use_nick == 0) {
					this.form.use_nick = false
				} else if(data.use_nick = 1){
					this.form.use_nick = true
				}
		  		if (data.sex == 0) {
					this.form.sex = '男'
				} else if(data.sex = 1){
					this.form.sex = '女'
				}



		  	})
			this.$store.commit('SET_ISBLUEACTIVE', true)
			this.$store.commit('SET_ISBLUECOLOR', false)
		},
		
	}
</script>

<style scoped>
	.information{
		background: #FBFBFB;
		padding-left: 20px;
		padding-bottom: 40px;
		color: #F48A65; padding-top: 15px;
	}
	.personChange{
		width: 70px;
		height: 70px;
		display: inline-block;
		vertical-align: middle;
		margin: 15px;
		border: 1px solid lightgray;
	}
	.changeMsg{
		display: inline-block;
		line-height: 64px;
		height: 64px;
		vertical-align: middle;
		padding-left: 50px;
		color: #606266;
	}
	.upload{
		display: inline;
	}
	.inputName{
		width: 412px;
		padding-left: 10px;
	}
	.selected{
		width: 135px;
	}
	.commitFirst{
		width: 322px;
		height: 86px;
		font-size: 33px;
		display: block;
		margin: 80px auto;
	}
	.rules img{
		padding-left: 20px;
		padding-right: 20px;
	}
	.rules{
		color: #F48A65;
	}
	.left .el-input__prefix{
		left: 15px;
	}
</style>


// WEBPACK FOOTER //
// src/views/information.vue